import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './App.js'
import './styles/reset.css';
import './styles/animations.css';
import './styles/hamburgers.min.css';
import './styles/main.css';

const ZENDO_HEALTH_V3_SECRET_KEY = '6LewfAUlAAAAAElO0dByzYt99ATLU43rRSuKDsVM';
const ZENDO_HEALTH_V3_SITE_KEY = '6LewfAUlAAAAAGCrALOlPbA6VCASqZ-fSSvHZo2f';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleReCaptchaProvider reCaptchaKey={ZENDO_HEALTH_V3_SITE_KEY}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </GoogleReCaptchaProvider>
);
